import { render, staticRenderFns } from "./TeacherProfile.vue?vue&type=template&id=307dde7c&scoped=true&"
import script from "./TeacherProfile.vue?vue&type=script&lang=js&"
export * from "./TeacherProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307dde7c",
  null
  
)

export default component.exports